/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>exceptionHandler.service.ts</name>
///
/// <description>
///  Global Exception Handler
///  Overrides Angular Exception handler and will log all exceptions and supress output to console 
///  
/// </description>
///
/// <author>Scott Grau</author>
/// <created>30 Sept 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 15Sep16 SG  1.0.0000         First cut 
/// 08Dec16     1.0.0000         Adding Calls to Log API; Setting addtional properties
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import {LogService} from "./log.service";
import {Injectable, Injector } from '@angular/core';
import {ErrorHandler} from '@angular/core';
import {LogEntry, Severity} from './Crestron.HydrogenAPI.LogApi.service'

@Injectable()
export class  ExceptionHandler implements ErrorHandler {
    private logService : LogService;
    private logEntry : LogEntry;
    injector: Injector;    
 
    constructor(injector: Injector) {        
        this.injector = injector;
    }
    
    public handleError( error: any ) : void {
        try {
            if (this.logService == null) {
                this.logService = this.injector.get(LogService);
            }           
            this.logEntry = new LogEntry();
            this.logEntry.message = "Exception Occured : " + error.message;
            
            if(error.stack != undefined)
            {
                this.logEntry.message = "Exception Occured : " + error.message + " at " + error.stack;
            }
            else
            {
                this.logEntry.message = "Exception Occured : " + error.message;
            }
            
            this.logEntry.severity = Severity.Error;
            this.logService.logLogEntry(this.logEntry);  
            console.log("Exception Occured : " + error.message);    
        }
        catch(exception)
        {
            console.log("Could not write error to log");
        }   
    }

  
}


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/exception-handler.service.ts